import { EntityInput, LinkProps } from "helpers/url";

/* Legacy, maybe deprecated */

export function partnerHref(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["href"] {
  return partnerAs(entity, region, origin);
}

export function partnerAs(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["as"] {
  const originSegment = origin || "";
  const regionSegment = region ? `r_${region}/` : "";
  return `${originSegment}/partners/${entity.alias}/${regionSegment}`;
}
